import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import BackupFileModel from "../models/BackupFileModel";

export interface RestoreDatabaseParam {
    fileName: string,
}

const DatabaseBackupApi = {
    GetBackupFiles() {
        return Api.get<unknown, BaseResponse<BackupFileModel[]>>("/api/DatabaseBackup/GetBackupFiles", null);
    },
    Restore(param: RestoreDatabaseParam) {
        return Api.post<RestoreDatabaseParam, BaseResponse<string>>("/api/DatabaseBackup/Restore", param);
    },
};
export default DatabaseBackupApi;